<template>
  <customModal :containerxl="true" @closeModal="closeModal">
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.tasklist") }}
        <span v-if="this.formPage == 'Task list data'"> : <b>{{ criticalInfo.riskId }}</b> - <b>{{ criticalInfo.riskName }}</b></span>
       
      </h4>
    </template>
    <template #body>
      
        <div class="table-responsive custom-dark-table-wrapper">
        <table class="table table-striped dark-table-head mb-0">
            <thead>
                <tr>
                <th> {{ $t("navigations.task title") }} </th>
                <th> {{ $t("navigations.description") }} </th>
                <th> {{ $t("navigations.owner") }} </th>
                <th> {{ $t("navigations.start date") }} </th>
                <th> {{ $t("navigations.end date") }} </th>
                <th> {{ $t("navigations.plannedEndDate") }} </th>
                <th> {{ $t("navigations.priority") }} </th>
                <th> {{ $t("navigations.status") }} </th>
                <th> {{ $t("navigations.comments") }} </th>
                </tr>
            </thead>
           
            <tbody v-if="this.formPage == 'Task list data'">
                <tr v-for="item in criticalInfo.taskList" :key="item.id">
                    <td> {{  item.taskTitle  }}</td>
                    <td> {{  item.description }}</td>
                    <td> {{  item.owner }}</td>
                    <td> {{  filter(item.startDate) }}</td>
                    <td> {{  filter(item.endDate) }}</td>  
                    <td> {{  filter(item.plannedEndDate) }}</td>
                    <td> {{  item.priority }}</td>
                    <td> {{  item.status }}</td>
                    <td> {{  item.comments }}</td> 
                </tr>
            </tbody>
        </table>
        </div>
    </template>
  </customModal>
</template>

<script src="./TaskListModal.js"></script>

<style scoped>

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.thead-primary {
  background-color: #0095ff !important;
  color: #ffffff !important;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.card {
  border-radius: 6px !important;
  border: 1px solid #dee2e6;
}
.patient-summary dl dt {
  font-weight: 500;
  color: #6c757d;
}

.patient-summary dl dd {
  margin-bottom: 0.1rem;
}
.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  border-radius: 6px 6px 0px 0px !important;
}
.card-header h6{
    font-size: .8rem !important;
    font-weight: 600 !important;
    color: #007bff;
}
</style>